// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__v8xlf","background":"Panel_background__3idPC","body":"Panel_body__JEiOv"};